export default class SubmitClick {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new SubmitClick(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick)
    }

    #handleClick = () => {
        document.querySelector(this.#element.dataset.gpTarget).submit()
    }
}
